<div class="modal-container">
	<mat-icon
		class="success-icon"
		svgIcon="pm-icons:check-circle"
		style="width: 80px; height: 80px"
	></mat-icon>
	<p class="success-message">{{ message }}</p>
</div>
